define('app/visualizations/StackedBarChart',['require','./SimpleCategoricalChartView','app/visualizations/FormatFactory'],function(require) {
	'use strict';

	var SimpleCategoricalChartView = require('./SimpleCategoricalChartView'),
		FormatFactory = require('app/visualizations/FormatFactory');

	var MAX_RECORDCOUNT = 50;

	return SimpleCategoricalChartView.extend({
		type: 'bar',

		initialize: function(options) {
			SimpleCategoricalChartView.prototype.initialize.call(this, options);
			this.paddingLeft = options.paddingLeft || 170;
		},

		getMaxRecordCount: function() {
			return MAX_RECORDCOUNT;
		},

		/**
		 * Get data used to populate the chart.
		 */
		getChartData: function(results) {
			// temporarily hardcoding the labels for evaluation purposes.  later we will need to determine
			// how to discover these values.
			return results.stackedBarData('Click-through', 'Drop-off', 'asc');
		},

		onClickChart: function(d) {
			this.drillDown(this.model.consumableResults().rows()[d.index - 1].rolledUpFields);
		},

		/**
		 * Get default options for rendering the chart.  Also provides callers the opportunity to customize
		 * various settings such as height, width, etc.
		 */
		getChartOptions: function(data) {
			var self = this;

			// Only format the aggregated column
			var column = self.model.columns().models.filter(function(col) {
				return col.get('aggregation');
			})[0];

			var dataOptions = {};

			if (column) {
				dataOptions = {
					enumeration: column.get('enumeration'),
					aggregation: column.get('aggregation'),
					displayFormat: column.get('displayFormat')
				};

				if (column.get('isPercentage')) {
					dataOptions.percentage = {
						total: column.get('total')
					};
				}

				dataOptions.dataType = column.get('fieldObject').get('type');
			}

			var getDataFormat = function(d) {
				if (dataOptions) {
					return FormatFactory.formatterForType(dataOptions.dataType, dataOptions)(d);
				} else {
					return d;
				}
			};

			var tooltipFormat = function(value) {
				return FormatFactory.formatterForType(dataOptions.dataType, dataOptions)(value);
			};

			var options = {
				c3: {
					color: {
						pattern: self.colors || ['#81adda', '#bc6c6d']
					},
					size: {
						height: self.height || self.$el.height(),
						width: self.width
					},
					legend: {
						position: 'right',
						show: self.showLegend
					},
					data: {
						labels: {
							format: function(v) {
								return (self.showLabels && v !== 0) ? getDataFormat(v) : '';
							}
						},
						type: self.type,
						columns: data.columns,
						groups: data.groups,
						onclick: function(d) {
							// Disable clicks for index 0 (Total), which is a row generated by the front end
							if (d.x !== 0) {
								self.onClickChart(d);
							}
						}
					},
					padding: {
						top: self.paddingTop,
						right: self.paddingRight,
						bottom: self.paddingBottom,
						left: self.paddingLeft
					},
					grid: {
						y: {
							lines: [{
								value: 0
							}]
						}
					},
					axis: {
						rotated: true,
						x: {
							type: 'categorized',
							categories: data.categories,
							tick: {
								multiline: false
							}
						},
						y: {
							tick: {
								format: getDataFormat
							}
						}
					},
					tooltip: {
						format: {
							value: tooltipFormat
						}
					}
				}
			};

			// special handling for tick marks.
			if (!this.showTicks) {
				this.$el.addClass('hide-ticks');

				options.c3.axis.x.tick = {
					outer: false
				};

				options.c3.axis.y.tick = {
					outer: false
				};
			}

			if (this.fixToolTips) {
				options.c3.tooltip.position = function() {
					return {
						top: 0,
						left: 0
					};
				};
			}

			if (this.isWidget) {
				options.c3.axis.x.show = false;
				options.c3.axis.y.show = false;
			}

			return options;
		}
	});

});

